export const createBasketQuantitiesBySku = (basketItems = []) => {
  // NOTE: please do not refactor to [].map() as it works much slower
  const result = {};
  for (let i = 0; i < basketItems.length; ++i) {
    const item = basketItems[i];
    result[item.sku] = item.quantity;
    if (item.parentSku) {
      result[item.parentSku] = item.derivativesQuantity;
    }
  }
  return result;
};
